import { render, staticRenderFns } from "./ApprovalClaimDeleteAction.vue?vue&type=template&id=88f65530"
import script from "./ApprovalClaimDeleteAction.vue?vue&type=script&lang=js"
export * from "./ApprovalClaimDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports